module.exports = __webpack_public_path__ + "img/img_career_tit.6361cf46.svg";